import { ArrowRight, Calendar, Sparkles, ShieldCheck } from "lucide-react";
import { SITE } from "../lib/api";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={SITE.hero}
          alt="Anton Pears DJ en prestation"
          className="w-full h-full object-cover scale-105"
          style={{ objectPosition: "center 25%" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/65 to-[#050505]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(59,130,246,0.18),transparent_55%)]" />
      </div>

      {/* Laser strips */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/4 left-0 w-[200%] h-[1px] bg-[#3B82F6]/40 blur-[2px]" style={{ animation: "laser 6s ease-in-out infinite" }} />
        <div className="absolute top-1/2 left-0 w-[200%] h-[1px] bg-[#3B82F6]/30 blur-[2px]" style={{ animation: "laser 8s ease-in-out infinite", animationDelay: "1.5s" }} />
        <div className="absolute top-3/4 left-0 w-[200%] h-[1px] bg-[#3B82F6]/20 blur-[2px]" style={{ animation: "laser 10s ease-in-out infinite", animationDelay: "3s" }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-16 w-full">
        {/* Badges */}
        <div className="flex flex-wrap gap-3 animate-fade-up delay-100" data-testid="hero-badges">
          <span className="glass px-4 py-2 rounded-full text-xs uppercase tracking-[0.25em] text-zinc-200 inline-flex items-center gap-2">
            <ShieldCheck size={14} className="text-[#3B82F6]" />
            Professionnel & Déclaré
          </span>
          <span className="glass px-4 py-2 rounded-full text-xs uppercase tracking-[0.25em] text-zinc-200 inline-flex items-center gap-2">
            <Sparkles size={14} className="text-[#3B82F6]" />
            Disponible 16 · 17 · 79 · 86 · Limitrophe Charente
          </span>
        </div>

        {/* Title */}
        <h1
          className="font-display mt-8 text-[19vw] md:text-[12vw] lg:text-[11rem] leading-[0.85] tracking-tight neon-text animate-fade-up delay-200"
          data-testid="hero-title"
        >
          ANTON
          <br />
          <span className="text-[#3B82F6]">PEARS</span>
        </h1>

        <div className="mt-6 max-w-2xl animate-fade-up delay-300">
          <p className="text-lg md:text-xl text-zinc-200 font-light" data-testid="hero-subtitle">
            DJ Professionnel en <span className="text-white font-semibold">Charente</span> &amp; <span className="text-white font-semibold">Nouvelle-Aquitaine</span>
          </p>
          <p className="mt-3 text-sm md:text-base text-zinc-400 tracking-wide" data-testid="hero-tagline">
            Mariages · Anniversaires · Soirées privées · Festivals · Événements professionnels
          </p>
        </div>

        {/* CTAs */}
        <div className="mt-10 flex flex-wrap gap-4 animate-fade-up delay-400" data-testid="hero-cta-group">
          <a href="#prestations" className="btn-neon" data-testid="hero-cta-prestations">
            Voir les prestations <ArrowRight size={18} />
          </a>
          <a href="#contact" className="btn-ghost" data-testid="hero-cta-reserver">
            Réserver une date
          </a>
          <a href="#disponibilites" className="btn-ghost" data-testid="hero-cta-dispo">
            <Calendar size={18} /> Voir les disponibilités
          </a>
        </div>

        {/* Stats strip */}
        <div className="mt-16 hidden md:grid grid-cols-3 gap-6 max-w-2xl animate-fade-up delay-500" data-testid="hero-stats">
          <div className="border-l border-[#3B82F6]/40 pl-4">
            <div className="font-display text-4xl">200+</div>
            <div className="text-xs uppercase tracking-[0.25em] text-zinc-400 mt-1">événements</div>
          </div>
          <div className="border-l border-[#3B82F6]/40 pl-4">
            <div className="font-display text-4xl">5</div>
            <div className="text-xs uppercase tracking-[0.25em] text-zinc-400 mt-1">zones</div>
          </div>
          <div className="border-l border-[#3B82F6]/40 pl-4">
            <div className="font-display text-4xl">100%</div>
            <div className="text-xs uppercase tracking-[0.25em] text-zinc-400 mt-1">satisfaction</div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#about"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-zinc-400 hover:text-[#3B82F6] z-10 text-[11px] uppercase tracking-[0.35em] flex flex-col items-center gap-2"
        style={{ animation: "float-y 2.4s ease-in-out infinite" }}
        data-testid="hero-scroll-indicator"
      >
        Découvrir
        <span className="w-px h-12 bg-gradient-to-b from-[#3B82F6] to-transparent" />
      </a>
    </section>
  );
}
